// Used for jumping pagination to top of results section instead of top of page.
// This is set at the layout level so can be used over other pages.
export const MAIN_SECTION_ID = 'main';

export const ARTIST_FEATURED_COLLECTION_LIMIT = 20;

export const DISALLOWED_ACCOUNT_STATES = ['DELETED', 'SUSPENDED'];
